import { Outlet } from 'react-router-dom';
import { useI18n } from '@/hooks/useI18n';
import { SiteHeader } from './SiteHeader';
import { SiteFooter } from './SiteFooter';

/**
 * Cascarón común de todas las páginas públicas: header fijo, contenido y
 * footer. Las rutas del portal de marcas usan su propio layout.
 */
export function SiteLayout() {
  const { t } = useI18n();

  return (
    <>
      <a href="#contenido" className="ilu-skip-link">
        {t.comun.saltarAlContenido}
      </a>
      <SiteHeader />
      <main id="contenido">
        <Outlet />
      </main>
      <SiteFooter />
    </>
  );
}
